import { render, staticRenderFns } from "./GalleryAdd.vue?vue&type=template&id=616aa4a6&"
import script from "./GalleryAdd.vue?vue&type=script&lang=js&"
export * from "./GalleryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports